import { FC, PropsWithChildren } from 'react';
import classNames from 'classnames';

import { StackDirection, StackSpacing } from './Stack.types';

import styles from './Stack.module.scss';

export type StackProps = PropsWithChildren<{
  direction?: StackDirection;
  spacing?: StackSpacing;
  className?: string;
}>;

export const Stack: FC<StackProps> = ({
  children,
  spacing = 1,
  direction = 'vertical',
}) => {
  return (
    <div
      // @ts-ignore
      style={{ '--spacing': spacing }}
      className={classNames(styles.root, {
        [styles.vertical]: direction === 'vertical',
      })}
    >
      {children}
    </div>
  );
};
